module.exports = __webpack_public_path__ + "img/status-change.f9a39370.png";